const Albums = () => {
    return <div>   
        okay okayokay okayokay okayokay okayokay okayokay okay
    </div>;
};

export {
    Albums
}